export default __webpack_public_path__ + "static/media/economical.68b99291.svg";